<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <path d="M16.2222 3H3.77778C2.79594 3 2 3.79594 2 4.77778V17.2222C2 18.2041 2.79594 19 3.77778 19H16.2222C17.2041 19 18 18.2041 18 17.2222V4.77778C18 3.79594 17.2041 3 16.2222 3Z" stroke="#202830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M13 1V5" stroke="#202830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M7 1V5" stroke="#202830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M3 9H18" stroke="#202830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
    name: 'IconCalendar',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
